import { render } from "./labTest.vue?vue&type=template&id=7e04d885&scoped=true"
import script from "./labTest.js?vue&type=script&lang=js"
export * from "./labTest.js?vue&type=script&lang=js"

import "./labTest.vue?vue&type=style&index=0&id=7e04d885&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e04d885"]])

export default __exports__